import notificationStreamIconModule from "../notificationStreamIconModule";

function notificationStreamIcon(notificationStreamUtility, $log) {
    "ngInject";

    return {
        restrict: "A",
        replace: true,
        scope: true,
        templateUrl: notificationStreamUtility.templates.notificationStreamIconTemplate
    }
}

notificationStreamIconModule.directive("notificationStreamIcon", notificationStreamIcon);

export default notificationStreamIcon;